import { useMutation } from "@tanstack/react-query";
import { FormModel } from "./types";
import { useEthereumVerifier } from "./useEthereumVerifier";
import { useSolanaVerifier } from "./useSolanaVerifier";
import { useLiberlandVerifier } from "./useLiberlandVerifier";


export const useVerifyReserves = () => {
    const ethVerifier = useEthereumVerifier();
    const solVerifier = useSolanaVerifier();
    const llVerifier = useLiberlandVerifier();

    return useMutation({
        mutationKey: ["verify"],
        mutationFn: async (formModel: FormModel) => {
            switch (formModel.toChain) {
                case "Ethereum":
                    return await ethVerifier.mutateAsync(formModel);
                case "Liberland":
                    return await llVerifier.mutateAsync(formModel);
                case "Solana":
                    return await solVerifier.mutateAsync(formModel);
                case "Tron":
                    return true; // Tron does not allow for easy transaction estimate
            }
        },
    });
};